import {mediaQueryBreakpointSM} from "../Utils/Utils.js";

const ACFBlockAnchorLinks = (domEl) => {

	const onLinkClicked = (e) => {
		e.preventDefault();

		const href = e.currentTarget.getAttribute('href');
		const target = ( href ? document.querySelector(href) : null );

		if(href && target) {
			const rect = target.getBoundingClientRect();
			const offset = e.currentTarget.dataset.offset ? e.currentTarget.dataset.offset : 0;

			window.scrollTo({
				top: rect.top + window.scrollY - offset - ( window.innerWidth < mediaQueryBreakpointSM ? 100 : 132 ), // Minus the header...
				behavior: "smooth",
			});
		}
	};
	domEl.querySelectorAll('a').forEach(link => link.addEventListener('click', onLinkClicked));
};

export default ACFBlockAnchorLinks;